const openLink = (link: string) => {
  window.open(link, '_blank')
}

export { openLink }
